import { net_common } from "@/api/http";
export const API_Initialize = (...params) =>
  net_common.post("/api/STDSDC02C05/Initialize", ...params);

export const API_UnlockBopData = (...params) =>
  net_common.post("/api/STDSDC02C05/UnlockBopData", ...params);

export const API_UpdateBopInfo = (...params) =>
  net_common.post("/api/STDSDC02C05/UpdateBopInfo", ...params);
